<div class="container">
  <div class="row flex-items-xs-center">
    <div class="col-xs-12 col-md-6 bg-cloud padding-2 margin-top-3">
      <sdx-card
        layout="inline-notification"
        notification-type="confirm"
        label="{{ 'register_step_3.label_card' | translate }}"
        label-aria-level="3">
        {{ "register_step_3.success_message" | translate }}
      </sdx-card>
    </div>
  </div>
  <div class="row flex-items-xs-center">
    <div class="col-xs-12 col-md-6 margin-top-3">
      <h1 class="h3 navy">{{ "register_step_3.header" | translate }}</h1>
      <p>{{ "register_step_3.tour_message" | translate }}</p>
      <sdx-button theme="primary" label="Start Tour" (click)="startTour()"></sdx-button>
    </div>
  </div>
</div>

<sdx-tour #MyTour>
  <section slot="step1">
    <h2 class="h5">{{ "register_step_3.tour_step_1_title" | translate }}</h2>
    <p>{{ "register_step_3.tour_step_1_description" | translate }}</p>
    <ul class="list single-line">
      <li>{{ "register_step_3.tour_step_1_feature_1" | translate }}</li>
      <li>{{ "register_step_3.tour_step_1_feature_2" | translate }}</li>
      <li>{{ "register_step_3.tour_step_1_feature_3" | translate }}</li>
    </ul>
  </section>
  <section slot="step2">
    <h2 class="h5">{{ "register_step_3.tour_step_2_title" | translate }}</h2>
    <p>{{ "register_step_3.tour_step_2_description" | translate }}</p>
    <ul class="list single-line">
      <li>{{ "register_step_3.tour_step_2_feature_1" | translate }}</li>
      <li>{{ "register_step_3.tour_step_2_feature_2" | translate }}</li>
      <li>{{ "register_step_3.tour_step_2_feature_3" | translate }}</li>
    </ul>
  </section>
  <section slot="step3">
    <h2 class="h5">{{ "register_step_3.tour_step_3_title" | translate }}</h2>
    <p>{{ "register_step_3.tour_step_3_description" | translate }}</p>
  </section>
</sdx-tour>
